import { Link } from "react-router-dom";
import { CalendarDays, UserRound } from "lucide-react";
import { RadioGroup, RadioGroupItem } from "./ui/radio-group";
import { Label } from "./ui/label";
import { cohortDayRange, cohortMonth, cohortYear } from "../lib/cohorts";

export const CohortSelector = ({ cohorts, value, onChange, error }) => {
  const trainer = cohorts[0];
  return (
    <div className="space-y-3" data-testid="cohort-selection">
      <Label className="text-sm font-semibold flex items-center gap-2">
        <CalendarDays className="h-4 w-4 text-brand" /> Choose your course dates *
      </Label>
      <RadioGroup value={value || ""} onValueChange={onChange} className="grid gap-2">
        {cohorts.map((c) => (
          <div key={c.id}>
            <RadioGroupItem value={c.id} id={`cohort-${c.id}`} className="peer sr-only" />
            <Label
              htmlFor={`cohort-${c.id}`}
              data-testid={`cohort-option-${c.id}`}
              className="flex items-center gap-4 p-3 border rounded-lg cursor-pointer transition-colors hover:border-brand/50 peer-data-[state=checked]:border-brand peer-data-[state=checked]:bg-brand/5 peer-data-[state=checked]:ring-2 peer-data-[state=checked]:ring-brand/20"
            >
              <span className="text-[11px] font-bold tracking-widest uppercase text-brand w-24 shrink-0">{cohortMonth(c)}</span>
              <span className="font-heading font-bold text-lg text-charcoal w-28 shrink-0">{cohortDayRange(c)}</span>
              <span className="text-sm text-muted-foreground">{cohortYear(c)}</span>
              {c.timezone && <span className="ml-auto text-[11px] text-muted-foreground">{c.timezone}</span>}
            </Label>
          </div>
        ))}
      </RadioGroup>
      {error && <p className="text-sm text-destructive" data-testid="cohort-error">{error}</p>}
      {trainer?.trainer_name && (
        <p className="text-xs text-muted-foreground flex items-center gap-1.5">
          <UserRound className="h-3.5 w-3.5" /> Trainer:{" "}
          {trainer.trainer_url ? (
            <Link to={trainer.trainer_url} className="text-brand font-medium hover:underline" data-testid="cohort-trainer-link">
              {trainer.trainer_name}
            </Link>
          ) : (
            <span className="font-medium">{trainer.trainer_name}</span>
          )}
        </p>
      )}
    </div>
  );
};
